export default __webpack_public_path__ + "static/program-circle-renewed-pl-0794f620ab88413872ab1189d1e3fffb.svg";